<script setup lang="ts">
import { useGetAdminAlgorithmVersion } from '@swipe4work/api-orval'
import { useTopBarTitle } from '@/shared/composables/UseTopBarTitle'

definePage({
  path: '/matching/algorithm-versions/:id',
  name: '/matching/AlgorithmVersionDetail',
  meta: {
    title: 'Algoritme versie',
    breadcrumbParent: '/matching/AlgorithmVersions',
    permission: {
      resource: 'MatchingAlgorithm',
      level: 'Read',
    },
  },
})

const route = useRoute('/matching/AlgorithmVersionDetail')
const router = useRouter()
const id = computed(() => Number((route.params as { id: string }).id))

const { data, isPending } = useGetAdminAlgorithmVersion(id, { query: { staleTime: 5 * 60 * 1000 } })
const version = computed(() => data.value?.algorithmVersion ?? null)

// The topbar shows the version label as the last breadcrumb once loaded.
useTopBarTitle(() => version.value?.version)

provide<ComputedRef<number>>('algorithmVersionId', id)

onBeforeMount(() => {
  if (route.name === '/matching/AlgorithmVersionDetail') {
    router.replace({
      name: '/matching/AlgorithmVersionDetail/overview' as any,
      params: { id: id.value },
    })
  }
})

watch(() => route.name, (name) => {
  if (name === '/matching/AlgorithmVersionDetail') {
    router.replace({
      name: '/matching/AlgorithmVersionDetail/overview' as any,
      params: { id: id.value },
    })
  }
})

const tabs = [
  {
    label: 'Overzicht',
    name: '/matching/AlgorithmVersionDetail/overview',
  },
  {
    label: 'Matchscores',
    name: '/matching/AlgorithmVersionDetail/match-scores',
  },
]
</script>

<template>
  <div class="space-y-5">
    <div v-if="isPending" class="flex flex-col gap-3">
      <Skeleton height="2rem" width="16rem" />
      <Skeleton height="1.25rem" width="24rem" />
    </div>

    <Tabs :value="route.name" scrollable>
      <TabList>
        <router-link
          v-for="tab in tabs"
          :key="tab.name"
          :to="{ name: tab.name as any, params: { id } }"
        >
          <Tab :value="tab.name">
            {{ tab.label }}
          </Tab>
        </router-link>
      </TabList>
    </Tabs>

    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </div>
</template>
